module.exports = __webpack_public_path__ + "img/EVENT.da42dd7e.svg";